export default "__VITE_ASSET__B_qG4SxX__"